Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Builders'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessReviewBuilder
  setText: (text) ->
    @text = text

  getText: ->
    @text

  setCreatedAt: (createdAt) ->
    @createdAt = createdAt

  getCreatedAt: ->
    @createdAt

  setContentId: (contentId) ->
    @contentId = contentId

  getContentId: ->
    @contentId

  setReviewId: (reviewId) ->
    @reviewId = reviewId

  getReviewId: ->
    @reviewId

  setStarRating: (starRating) ->
    @starRating = starRating

  getStarRating: ->
    @starRating

  build: ->
    new Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReview(@)
